import React from "react";
import { Button, Card, Space, Table, Tag, Typography } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

import { OPERATION_TYPE_LABELS } from "../../constants";
import { formatDateTime } from "../../utils/formatters";

const { Paragraph, Text } = Typography;

const OperationLogsTable = ({ logs, loading, pagination, onRefresh, onChange }) => {
    return (
        <Card
            size="small"
            title="周期审计历史"
            extra={
                <Button icon={<ReloadOutlined />} onClick={onRefresh}>
                    刷新
                </Button>
            }
        >
            <Paragraph type="secondary" style={{ marginTop: 0 }}>
                这里聚合所有价格周期的审计留痕，用于追溯创建、价格录入、状态确认与争议动作。
            </Paragraph>
            <Table
                rowKey="id"
                dataSource={logs}
                loading={loading}
                size="small"
                pagination={{
                    ...pagination,
                    showTotal: (total) => `共 ${total} 条`,
                }}
                onChange={onChange}
                columns={[
                    {
                        title: "时间",
                        dataIndex: "created_at",
                        width: 170,
                        render: (value) => formatDateTime(value),
                    },
                    {
                        title: "操作类型",
                        dataIndex: "operation_type",
                        width: 140,
                        render: (value) => <Tag>{OPERATION_TYPE_LABELS[value] || value}</Tag>,
                    },
                    {
                        title: "周期 ID",
                        dataIndex: "target_id",
                        width: 90,
                    },
                    {
                        title: "操作人",
                        dataIndex: "operator_name",
                        width: 120,
                        render: (value) => value || <Text type="secondary">系统</Text>,
                    },
                    {
                        title: "描述",
                        dataIndex: "description",
                        render: (value) => (
                            <Space direction="vertical" size={0}>
                                <Text>{value || "-"}</Text>
                            </Space>
                        ),
                    },
                ]}
            />
        </Card>
    );
};

export default OperationLogsTable;
